
import { CustomToaster } from "../../../reusable-components/Toasters/toaster";

export const DownloadSummaryExcel = async (summaryBlob) => {
    if (summaryBlob !== undefined) {
        try {
            const href = window.URL.createObjectURL(summaryBlob);
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', 'summary.xlsx'); //or any other extension
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (err) {
            console.log("Download Excel function has an error: ", err)
            CustomToaster({ type: "error", customized_message: "The K-1s were summarized but the download failed. Please contact support and attach a screenshot.", api_message: err })
        }
    }
};

export const DownloadURI = (url, name) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = name;
    document.body.appendChild(link);
    window.open(url)
    document.body.removeChild(link);
}

export const CreatedDateRenderer = (date) => {
    const formatDateTime = (dateTimeString) => {
        // Convert the input string to a Date object in the specified timezone offset
        const date = new Date(dateTimeString + '-05:52'); // Append the timezone offset to the input string

        // Adjust to user's local timezone
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');

        // Format hours, minutes, and seconds
        let hour = date.getHours();
        const minute = String(date.getMinutes()).padStart(2, '0');
        const second = String(date.getSeconds()).padStart(2, '0');

        // Determine AM/PM notation
        const ampm = hour >= 12 ? 'PM' : 'AM';
        hour = hour % 12;
        hour = hour ? hour : 12; // Hour '0' should be '12'
        const formattedHour = String(hour).padStart(2, '0');

        // Format as "YYYY-MM-DD h:mm:ss A"
        return `${year}-${month}-${day} ${formattedHour}:${minute}:${second} ${ampm}`;
    };

    return (
        <span>
            {formatDateTime(date)}
        </span>
    )
}